export const APP_NAME = 'Want2ride';

export const REFRESH_HOME_WEATHER_INTERVAL = 1800000;

export const PATH_TO_USERS_DIRECTORY = 'users';
export const USER_MOTORCYCLE_DIRECTORY = 'my-motorcycles';
export const USER_MAP_DIRECTORY = 'my-maps';

export const MAX_MOTORCYCLES_PHOTOS_COUNT = 5;
